// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_enum-bug-keys.js
// module id = hOe3
// module chunks = 11